module.exports = __webpack_public_path__ + "media/assets/consultation/platform_others-daad1d940ec70385db33d72b9ce64866.svg";